import { Component, EventEmitter, Input, OnInit, OnDestroy, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { OrderEntryComponent } from './order-entry.component';
import { Budget, SubBudget, Material } from '../../budget/interfaces/index';
import { DataService } from '../../services/data.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { switchMap, map } from 'rxjs/operators';

@Component({
  selector: 'app-order-entry-array',
  templateUrl: './order-entry-array.component.html',
  styleUrls: ['./order-entry-array.component.scss']
})
export class OrderEntryArrayComponent implements OnInit, OnDestroy {


  constructor(private dataService: DataService) { }

  private _budget: Budget;

  public total$: Observable<number>;

  @Input()
  public itemsFormArray: FormArray;
  @Input()
  public isInvoicesAndDdt: boolean;

  static buildItems(items?) {
    if (!items) {
      return new FormArray([
        OrderEntryComponent.buildItem()
      ], Validators.minLength(1));
    } else {
      const entryItems = [];
      items.forEach(element => {
        entryItems.push(OrderEntryComponent.buildItem(element));
      });
      return new FormArray(entryItems, Validators.minLength(1));
    }
  }

  ngOnInit() {
    this.total$ = this.itemsFormArray.valueChanges
    .map((entryArray) => {
       return entryArray
        .map((i) =>  OrderEntryComponent.calculateEntryValue(i))
        .reduce((a, b) => a + b, 0);
    });
    // this.itemsFormArray.controls
    // .map((i) =>  OrderEntryComponent.calculateEntryValue(i.value))
    // .reduce((a, b) => a + b, 0);
  }

  ngOnDestroy() {

  }

  addItem(item?) {
    this.itemsFormArray.push(OrderEntryComponent.buildItem(item));
  }



}

// class ItemsValidators {

//   // static minQuantitySum(val: number) {
//   //   return (c: AbstractControl) => {
//   //     const sum = c.value
//   //       .map(item => item.quantity)
//   //       .reduce((acc, cur) => acc + cur, 0);
//   //     if (sum < val) {
//   //       return { minSum: val };
//   //     }
//   //   };
//   // }

//   static minItems(val: number) {
//     return (c: AbstractControl) => {
//       return (c.value.length && c.value.length > val);
//     };
//   }
// }




// WEBPACK FOOTER //
// ./src/app/order/components/order-entry-array.component.ts